/** @format */
import { request } from '@power/runtime-vue3';
import type { BaseResponse } from '@power/runtime-vue3';

export * from './dict';

export function queryNotReadMsgList() {
	return new Promise((resolve) => {
		setTimeout(() => {
			return resolve({ rows: [], total: 0 });
		}, 1000);
	});
}

// 文件上传
export function uploadFile(file, alias) {
	const data = new FormData(); // 创建form对象
	data.append('file', file);
	data.append('folderAlias', alias);
	data.append('groupKey', '');
	return request<BaseResponse>({
		url: '/file/upload',
		method: 'post',
		timeout: 0,
		data,
	});
}
